import { render } from "./GermanyMap.vue?vue&type=template&id=54d6935a&scoped=true"
const script = {}

import "./GermanyMap.vue?vue&type=style&index=0&id=54d6935a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54d6935a"

export default script